<template>
  <div class="tag-object d-flex p-1 px-2" :class="deleteToggled ? 'active-delete' : ''">
    <span class="pr-2">{{ tag.name }}</span>
    <div class="pl-2" style="border-left: solid 2px #000000">
      <span>
        <i class="fas fa-times" style="cursor: pointer;" @click="deleteToggled = !deleteToggled"></i>
      </span>
    </div>
    <b-modal v-model="deleteToggled" hide-header hide-footer>
      <div class="d-flex flex-column align-items-center justify-content-center p-4" style="background: #FFFFFF; color: #000000">
        <div>
          Are you sure you want to delete this tag?
        </div>
        <div class="d-flex mt-3">
          <div>
            <button class="btn btn-success btn-sm mx-2" @click="deleteTag">YES</button>
          </div>
          <div>
            <button class="btn btn-dark btn-sm mx-2" @click="deleteToggled = !deleteToggled">NO</button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import startupResourcesAPI from '../../api/startupResources'

export default {
  name: '',
  props: ['tag', 'resourceID'],
  data: function () {
    return {
      deleteToggled: false
    }
  },
  methods: {
    deleteTag () {
      startupResourcesAPI.removeTagFromResource(this.resourceID, this.tag.id).then(
        response => {
          if (response.data.success) {
            this.deleteToggled = false
            this.$emit('tagRemoved', this.tag.id)
          }
        }
      )
    }
  }
}
</script>

<style scoped>
.tag-object {
  background: #dddddd;
  font-size: 0.9em;
  border-radius: 5px;
}
.fa-times:hover {
  color: #be1e2d;
}
.active-delete {
  background: #be1e2d;
  color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/components/startupResources/ResourceTag.vue